import React, {useEffect, useState} from 'react';
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { Toast } from 'primereact/toast';
import logo from '../../assets/img/SUMATELLEVA_BCO.png'
import IDLogo from '../../assets/img/LOGO_ID_BLANCO_NARANJA.png';
import {Divider} from "primereact/divider";
import {Link} from "react-router-dom";
import {sendEmail} from "./integracion";

const PasswordRecovery = () => {
    const [email, setEmail] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isSuccessful, setIsSuccessful] = useState(false);
    const [isMobile, setIsMobile] = useState(false);
    const toast = React.useRef(null);

    const colors = {
        orange: '#07243b',
        lightOrange: '#0b7ad1',
        darkBlue: '#2c3e50',
        lightBlue: '#f5f7fa',
        white: '#ffffff',
        gray: '#95a5a6',
        darkGray: '#333333'
    };

    // Detectar tamaño de pantalla para ajuste responsivo
    useEffect(() => {
        const checkScreenSize = () => {
            setIsMobile(window.innerWidth < 768);
        };

        // Verificar tamaño inicial
        checkScreenSize();

        // Agregar event listener para cambios de tamaño
        window.addEventListener('resize', checkScreenSize);

        // Cleanup
        return () => window.removeEventListener('resize', checkScreenSize);
    }, []);


    const handleSubmit = (e) => {
        e.preventDefault();

        if (!email) {
            toast.current.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Por favor ingrese su correo electrónico',
                life: 3000
            });
            return;
        }

        setIsSubmitting(true);

        // Simulation of sending recovery email
        sendEmail(email).then(() => {
            setIsSubmitting(false);
            setIsSuccessful(true);
            /*toast.current.show({
                severity: 'success',
                summary: 'Éxito',
                detail: 'Se ha enviado un correo con tu contraseña',
                life: 5000
            });*/
        })
    };

    return (
        <div style={{
            display: 'flex',
            flexDirection: isMobile ? 'column' : 'row',
            minHeight: '100vh',
            width: '100%',
            backgroundColor: colors.lightBlue
        }}>
            <Toast ref={toast} />
            {/* Left side - App information */}
            <div style={{
                flex: isMobile ? 'none' : '1',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                background: `linear-gradient(135deg, ${colors.orange}, ${colors.lightOrange})`,
                color: colors.white,
                padding: isMobile ? '2rem 1rem' : '2rem 3rem',
                position: 'relative',
                overflow: 'hidden',
                minHeight: isMobile ? 'auto' : '100vh',
                boxShadow: '0 0 20px rgba(0, 0, 0, 0.1)'
            }}>
                {/* Decorative elements */}
                <div style={{
                    position: 'absolute',
                    width: '300px',
                    height: '300px',
                    borderRadius: '50%',
                    backgroundColor: 'rgba(255, 255, 255, 0.1)',
                    top: '-100px',
                    left: '-100px',
                    zIndex: 0
                }}></div>
                <div style={{
                    position: 'absolute',
                    width: '200px',
                    height: '200px',
                    borderRadius: '50%',
                    backgroundColor: 'rgba(255, 255, 255, 0.1)',
                    bottom: '50px',
                    right: '-50px',
                    zIndex: 0
                }}></div>
                <div style={{
                    position: 'absolute',
                    width: '150px',
                    height: '150px',
                    borderRadius: '50%',
                    backgroundColor: 'rgba(255, 255, 255, 0.08)',
                    top: '30%',
                    right: '15%',
                    zIndex: 0
                }}></div>

                {/* Suma Logo in top left */}
                <div style={{
                    position: 'absolute',
                    top: '20px',
                    left: '20px',
                    zIndex: 5
                }}>
                    <img src={logo} alt="logo-suma" style={{
                        width: isMobile ? '100px' : '150px'
                    }}/>
                </div>

                {/* I+D Logo */}
                <div style={{
                    zIndex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    marginBottom: '2rem',
                    marginTop: isMobile ? '4rem' : '0'
                }}>
                    <div style={{
                        width: isMobile ? '100px' : '140px',
                        height: isMobile ? '100px' : '140px',
                        borderRadius: '50%',
                        backgroundColor: colors.darkBlue,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        marginBottom: '2rem',
                        boxShadow: '0 8px 30px rgba(0, 0, 0, 0.3)',
                        border: '5px solid rgba(255, 255, 255, 0.2)'
                    }}>
                        <img src={IDLogo} alt="logo-I+D" style={{
                            width: isMobile ? '70px' : '100px'
                        }}/>
                    </div>
                </div>

                <div style={{zIndex: 1, maxWidth: '600px', textAlign: isMobile ? 'center' : 'left'}}>
                    <h1 style={{
                        fontSize: isMobile ? '2.5rem' : '3.5rem',
                        marginBottom: '1rem',
                        fontWeight: '700',
                        textShadow: '2px 2px 4px rgba(0, 0, 0, 0.2)'
                    }}>Portal Suma</h1>

                    <h2 style={{
                        fontSize: isMobile ? '1.4rem' : '1.8rem',
                        marginBottom: '1.5rem',
                        fontWeight: '400',
                        letterSpacing: '1px'
                    }}>Plataforma de Gestión interna</h2>

                    <Divider style={{
                        backgroundColor: 'rgba(255, 255, 255, 0.3)',
                        margin: '1.5rem 0',
                        width: isMobile ? '80%' : '60%'
                    }}/>

                    {!isMobile && (
                        <p style={{
                            fontSize: '1.1rem',
                            lineHeight: '1.8',
                            marginBottom: '2.5rem',
                            textShadow: '1px 1px 2px rgba(0, 0, 0, 0.1)'
                        }}>
                            Este sitio web es una plataforma integral diseñada para la gestión operativa, administrativa
                            y de talento humano de Suma. Su objetivo principal es centralizar y optimizar
                            los procesos internos, brindando a cada área las herramientas necesarias para llevar un
                            control eficiente, tomar decisiones informadas y mejorar la productividad.
                        </p>
                    )}
                </div>
            </div>

            {/* Right side - Password Recovery Form */}
            <div style={{
                flex: '1',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                padding: '2rem',
                position: 'relative'
            }}>
                <Card style={{
                    width: '80%',
                    maxWidth: '500px',
                    borderRadius: '12px',
                    boxShadow: '0 10px 30px rgba(0, 0, 0, 0.1)',
                    border: 'none'
                }}>
                    <div style={{padding: '1rem'}}>
                        <h2 style={{
                            color: colors.darkBlue,
                            marginBottom: '1rem',
                            textAlign: 'center',
                            fontSize: '1.8rem'
                        }}>Recuperar Contraseña</h2>

                        <p style={{
                            color: colors.darkGray,
                            textAlign: 'center',
                            marginBottom: '1.5rem',
                            fontSize: '1rem'
                        }}>
                            Ingresa tu correo electrónico y te enviaremos tu contraseña
                        </p>

                        {!isSuccessful ? (
                            <form onSubmit={handleSubmit}>
                                <div style={{marginBottom: '1.5rem'}}>
                                    <label style={{
                                        display: 'block',
                                        marginBottom: '0.5rem',
                                        color: colors.darkBlue,
                                        fontWeight: '500'
                                    }}>
                                        Correo electrónico
                                    </label>
                                    <div style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        border: `1px solid ${colors.gray}`,
                                        borderRadius: '8px',
                                        overflow: 'hidden'
                                    }}>
                                        <div style={{
                                            backgroundColor: '#f4f4f4',
                                            padding: '0.75rem',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center'
                                        }}>
                                            <i className="pi pi-envelope" style={{color: colors.orange}}></i>
                                        </div>
                                        <input
                                            type="email"
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                            style={{
                                                flex: 1,
                                                padding: '0.75rem',
                                                border: 'none',
                                                outline: 'none',
                                                fontSize: '1rem'
                                            }}
                                            placeholder="nombre@ejemplo.com"
                                            required
                                        />
                                    </div>
                                </div>

                                <Button
                                    type="submit"
                                    icon="pi pi-sync"
                                    iconPos="left"
                                    label="Enviar Contraseña"
                                    className="p-button-raised"
                                    loading={isSubmitting}
                                    style={{
                                        backgroundColor: colors.darkBlue,
                                        border: 'none',
                                        width: '100%',
                                        padding: '0.75rem',
                                        borderRadius: '8px',
                                        fontSize: '1rem',
                                        fontWeight: '600',
                                        marginBottom: '1rem'
                                    }}
                                />
                            </form>
                        ) : (
                            <div style={{
                                textAlign: 'center',
                                padding: '1rem',
                                backgroundColor: 'rgba(46, 204, 113, 0.1)',
                                borderRadius: '8px',
                                marginBottom: '1.5rem'
                            }}>
                                <i className="pi pi-check-circle" style={{
                                    fontSize: '2rem',
                                    color: '#2ecc71',
                                    marginBottom: '1rem',
                                    display: 'block'
                                }}></i>
                                <p style={{color: colors.darkGray}}>
                                    Se ha enviado tu contraseña a la dirección de correo electrónico proporcionada.
                                </p>
                            </div>
                        )}

                        <div style={{
                            textAlign: 'center',
                            marginTop: '1rem'
                        }}>
                            <Link to="/" style={{
                                color: colors.orange,
                                textDecoration: 'none',
                                fontSize: '1rem',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}>
                                <i className="pi pi-arrow-left" style={{marginRight: '0.5rem'}}></i>
                                Volver a iniciar sesión
                            </Link>
                        </div>
                    </div>
                </Card>

                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginTop: '2rem'
                }}>
                    <div style={{
                        color: colors.gray,
                        fontSize: '0.9rem',
                        textAlign: 'center'
                    }}>
                        © 2025 Suma - Todos los derechos reservados
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PasswordRecovery;